// 8글자 채팅 규칙: "iamacapybara"에 들어 있는 글자와 띄어쓰기만, 최대 16자.
export const CHAT_LETTERS = 'abcimpry';
export const CHAT_MAX = 16;
export function isAllowedChat(text: string): boolean {
  if (text.length === 0 || text.length > CHAT_MAX) return false;
  return [...text].every((ch) => ch === ' ' || CHAT_LETTERS.includes(ch));
}
